import controller from './free-draw.controller';
import template from './free-draw.html';

export default {
	template,
	bindings: {
		width: '@',
		height: '@',
		lineWidth: '@',
		strokeColor: '@',
		backgroundColor: '@',
		disabled: '@',

		onSave: '&',
		onCancel: '&',
	},
	controller,
	controllerAs: '$ctrl',
};
